export const queryKeys = {
    mems: "mems",
}

export const memsCategory = {
    HOT: "HOT",
    REGULAR: "REGULAR"
}